// Approving a task whose stage may need the approver's passkey. Such a stage
// is approved on the signing page, which shows exactly what is being approved;
// the server refuses an inline answer there. Pure, with the answer and the
// signing page passed in, so each branch is unit tested.

import { isPasskeyApprovalRefusal } from "state/members/stepUpFailure";

export type TaskApproveOutcome =
  /** Answered inline. */
  | "approved"
  /** Sent to the signing page, which confirms once signed. */
  | "signing"
  /** Neither; the reason has already been shown. */
  | "failed";

/**
 * The task says up front when its stage needs a passkey (`passkeyRequired`).
 * A server that predates the flag says so by refusing the inline answer, and
 * that refusal opens the signing page too rather than ending in an error.
 * The approver's note goes whichever way the approval does.
 */
export const approveTask = async (
  passkeyRequired: boolean | undefined,
  note: string | undefined,
  deps: {
    respond: (note?: string) => Promise<unknown>;
    /** Opens the signing page; false when it could not (and said why). */
    sign: (note?: string) => Promise<boolean>;
  },
): Promise<TaskApproveOutcome> => {
  const sign = async (): Promise<TaskApproveOutcome> =>
    (await deps.sign(note)) ? "signing" : "failed";
  if (passkeyRequired) return sign();
  try {
    await deps.respond(note);
    return "approved";
  } catch (error) {
    return isPasskeyApprovalRefusal(error) ? sign() : "failed";
  }
};
